/* The Mora Gold House – collection catalog: filter drawer, auto-apply on desktop, price slider, sorting, in-page filters (chain type, gender, gold color, length, width), grid/list view, variant preview on cards. */
(()=>{
  document.documentElement.classList.add('js-mgh');
  const isDesktop=()=>window.matchMedia('(min-width: 990px)').matches;
  const store={get(k){try{return localStorage.getItem(k);}catch(e){return null;}},set(k,v){try{localStorage.setItem(k,v);}catch(e){}}};
  const TX=k=>(window.MGH_T||{})[k];
  const GENDER_LABEL={get female(){return TX('women')||'Women';},get male(){return TX('men')||'Men';},get unisex(){return TX('unisex')||'Unisex';}};
  const GENDER_ORDER=['female','male','unisex'];
  const SWATCH={'yellow gold':'linear-gradient(135deg,#f6d77a,#c89600)','white gold':'linear-gradient(135deg,#ffffff,#cfcfcf)','rose gold':'linear-gradient(135deg,#f3c1b0,#b76e5a)','tri-color gold':'conic-gradient(#c89600 0 33%,#e6e6e6 0 66%,#c98a7a 0)'};
  const listOf=s=>[...new Set((s||'').split('|').map(v=>v.trim()).filter(Boolean))];
  const cap=s=>s.charAt(0).toUpperCase()+s.slice(1);
  function init(root){
    if(root.dataset.mghInit==='1')return;
    root.dataset.mghInit='1';
    const form=root.querySelector('[data-mgh-filter-form]');
    const panel=root.querySelector('[data-mgh-filters]');
    const overlay=root.querySelector('.mgh-cat__overlay');
    const openBtn=root.querySelector('[data-mgh-filter-open]');
    const sortSel=root.querySelector('[data-mgh-sort]');
    /* price range sliders */
    root.querySelectorAll('[data-mgh-range]').forEach(r=>{
      const min=r.querySelector('[data-min]'),max=r.querySelector('[data-max]');
      const outMin=r.querySelector('[data-min-out]'),outMax=r.querySelector('[data-max-out]');
      const top=parseFloat(r.dataset.max)||parseFloat(max.max)||0;
      const fmt=v=>(r.dataset.symbol||'$')+Math.round(v).toLocaleString();
      const sync=src=>{
        let a=parseFloat(min.value)||0,b=parseFloat(max.value)||top;
        if(a>b){if(src===min){a=b;min.value=a;}else{b=a;max.value=b;}}
        r.style.setProperty('--a',(top?a/top*100:0)+'%');r.style.setProperty('--b',(top?b/top*100:100)+'%');
        if(outMin)outMin.textContent=fmt(a);if(outMax)outMax.textContent=fmt(b);
      };
      min.addEventListener('input',()=>sync(min));max.addEventListener('input',()=>sync(max));sync();
    });
    const submit=()=>{
      if(!form)return;
      const params=new URLSearchParams();
      for(const el of form.elements){
        if(!el.name||el.disabled)continue;
        if((el.type==='checkbox'||el.type==='radio')&&!el.checked)continue;
        if(el.value==='')continue;
        if(el.hasAttribute('data-min')&&parseFloat(el.value)<=parseFloat(el.min||0))continue;
        if(el.hasAttribute('data-max')&&parseFloat(el.value)>=parseFloat(el.max))continue;
        params.append(el.name,el.value);
      }
      if(sortSel&&!params.has('sort_by'))params.append('sort_by',sortSel.value);
      const qs=params.toString();
      window.location.href=form.getAttribute('action')+(qs?'?'+qs:'');
    };
    form?.addEventListener('submit',e=>{e.preventDefault();submit();});
    form?.addEventListener('change',e=>{if(e.target.matches('[data-mgh-style-check],[data-mgh-cf-check]'))return;if(isDesktop())submit();});
    sortSel?.addEventListener('change',submit);
    /* drawer */
    const open=()=>{
      if(!panel)return;
      panel.classList.add('is-open');panel.setAttribute('role','dialog');panel.setAttribute('aria-modal','true');
      if(overlay)overlay.hidden=false;
      openBtn?.setAttribute('aria-expanded','true');
      document.body.classList.add('mgh-no-scroll');
      panel.querySelector('.mgh-cat__close')?.focus();
    };
    const close=()=>{
      if(!panel||!panel.classList.contains('is-open'))return;
      panel.classList.remove('is-open');panel.removeAttribute('role');panel.removeAttribute('aria-modal');
      if(overlay)overlay.hidden=true;
      openBtn?.setAttribute('aria-expanded','false');
      document.body.classList.remove('mgh-no-scroll');
      openBtn?.focus();
    };
    openBtn?.addEventListener('click',open);
    root.querySelectorAll('[data-mgh-filter-close]').forEach(b=>b.addEventListener('click',close));
    document.addEventListener('keydown',e=>{if(e.key==='Escape')close();});
    window.matchMedia('(min-width: 990px)').addEventListener?.('change',e=>{if(e.matches)close();});
    /* in-page filters */
    const cards=[...root.querySelectorAll('[data-mgh-card]')];
    const countEl=root.querySelector('[data-mgh-count]');
    const totalText=countEl?countEl.textContent:'';
    const none=root.querySelector('[data-mgh-none]');
    const badge=root.querySelector('[data-mgh-badge]');
    const badgeSr=root.querySelector('[data-mgh-badge-sr]');
    const serverActive=badge?(parseInt(badge.textContent,10)||0):0;
    const styleChecks=[...root.querySelectorAll('[data-mgh-style-check]')];
    const chips=[...root.querySelectorAll('[data-mgh-style]')];
    const cardVals=(c,key)=>listOf(c.dataset['f'+cap(key)]);
    root.querySelectorAll('[data-mgh-cf]').forEach(group=>{
      const key=group.dataset.mghCf;const counts=new Map();
      cards.forEach(c=>cardVals(c,key).forEach(v=>counts.set(v,(counts.get(v)||0)+1)));
      if(!counts.size){group.remove();return;}
      let vals=[...counts.keys()];
      if(key==='length'||key==='width')vals.sort((a,b)=>parseFloat(a)-parseFloat(b));
      else if(key==='gender')vals.sort((a,b)=>{const ia=GENDER_ORDER.indexOf(a.toLowerCase()),ib=GENDER_ORDER.indexOf(b.toLowerCase());return (ia<0?9:ia)-(ib<0?9:ib);});
      else vals.sort();
      const ul=group.querySelector('ul');
      vals.forEach(v=>{
        const li=document.createElement('li');const lab=document.createElement('label');lab.className='mgh-check';
        const inp=document.createElement('input');inp.type='checkbox';inp.value=v;inp.dataset.mghCfCheck='';inp.dataset.key=key;
        lab.appendChild(inp);
        if(key==='color'){const sw=document.createElement('span');sw.className='mgh-swatch';sw.setAttribute('aria-hidden','true');sw.style.background=SWATCH[v.toLowerCase()]||'#c89600';lab.appendChild(sw);}
        const t=document.createElement('span');t.textContent=key==='gender'?(GENDER_LABEL[v.toLowerCase()]||v):v;lab.appendChild(t);
        const n=document.createElement('span');n.className='mgh-check__count';n.textContent='('+counts.get(v)+')';lab.appendChild(document.createTextNode(' '));lab.appendChild(n);
        li.appendChild(lab);ul.appendChild(li);
      });
      group.hidden=false;
    });
    const cfChecks=[...root.querySelectorAll('[data-mgh-cf-check]')];
    const apply=()=>{
      const kws=[];styleChecks.forEach(c=>{if(c.checked)c.value.split(',').forEach(k=>{k=k.trim();if(k)kws.push(k);});});
      const sel={};let active=styleChecks.filter(c=>c.checked).length;
      cfChecks.forEach(i=>{if(i.checked){(sel[i.dataset.key]=sel[i.dataset.key]||[]).push(i.value);active++;}});
      let n=0;
      cards.forEach(c=>{
        let show=!kws.length||kws.some(k=>(c.dataset.title||'').includes(k));
        if(show)for(const key in sel){const have=cardVals(c,key);if(!sel[key].some(v=>have.includes(v))){show=false;break;}}
        c.hidden=!show;if(show)n++;
      });
      const filtering=active>0;
      if(countEl)countEl.textContent=filtering?(n+' '+(n===1?(TX('piece')||'piece'):(TX('pieces')||'pieces'))):totalText;
      if(none)none.hidden=n>0;
      const total=serverActive+active;
      if(badge){badge.textContent=total;badge.hidden=total===0;}
      if(badgeSr)badgeSr.textContent=total?total+' '+(TX('active')||'active'):'';
    };
    [...styleChecks,...cfChecks].forEach(c=>c.addEventListener('change',()=>{
      if(c.matches('[data-mgh-style-check]'))chips.forEach(o=>{const kw=o.dataset.mghStyle||'';const a=kw?styleChecks.some(s=>s.checked&&s.value===kw):!styleChecks.some(s=>s.checked);o.classList.toggle('is-active',a);o.setAttribute('aria-pressed',String(a));});
      apply();
    }));
    chips.forEach(ch=>ch.addEventListener('click',e=>{
      e.preventDefault();const kw=ch.dataset.mghStyle||'';
      chips.forEach(o=>{const a=(o.dataset.mghStyle||'')===kw;o.classList.toggle('is-active',a);o.setAttribute('aria-pressed',String(a));});
      styleChecks.forEach(c=>{c.checked=!!kw&&c.value===kw;});
      apply();
    }));
    root.querySelector('[data-mgh-style-reset]')?.addEventListener('click',()=>{
      [...styleChecks,...cfChecks].forEach(c=>c.checked=false);
      chips.forEach(o=>{const a=!o.dataset.mghStyle;o.classList.toggle('is-active',a);o.setAttribute('aria-pressed',String(a));});
      apply();
    });
    /* grid / list view */
    const grid=root.querySelector('[data-mgh-grid]');
    const viewBtns=[...root.querySelectorAll('[data-mgh-view]')];
    const setView=v=>{if(!grid)return;grid.classList.toggle('is-list',v==='list');viewBtns.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.mghView===v)));store.set('mghView',v);};
    viewBtns.forEach(b=>b.addEventListener('click',()=>setView(b.dataset.mghView)));
    if(store.get('mghView')==='list'&&window.matchMedia('(min-width: 750px)').matches)setView('list');
    /* variant preview on cards (no add to cart) */
    root.querySelectorAll('[data-mgh-variant]').forEach(sel=>{
      sel.addEventListener('change',()=>{
        const opt=sel.options[sel.selectedIndex];const card=sel.closest('[data-mgh-card]');if(!card||!opt)return;
        const price=card.querySelector('[data-mgh-price]');if(price&&opt.dataset.price)price.innerHTML=opt.dataset.price;
        card.querySelectorAll('[data-mgh-link]').forEach(a=>{if(opt.dataset.url)a.href=opt.dataset.url;});
        const stock=card.querySelector('[data-mgh-stock]');
        if(stock){const ok=opt.dataset.available==='true';stock.classList.toggle('is-out',!ok);stock.textContent=ok?(TX('in_stock')||'In stock'):(TX('sold_out')||'Sold out');}
      });
    });
  }
  const all=()=>document.querySelectorAll('[data-mgh-cat]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-mgh-cat]').forEach(init));
})();
